const COMMISSION_STATUS_ORDER = [
  'liberado',
  'solicitado',
  'em_transferencia',
  'em_andamento',
  'concluido',
  'cancelado',
];
const INVESTMENT_TEMPERATURE_ORDER = ['frio', 'morno', 'quente'];
const mainLabel = (t, id) => {
  if (id === 'principal')
    return t('REAL_ESTATE_BROKER_DASHBOARD.MOBILE_NAV.PRINCIPAL');
  if (id === 'commission')
    return t('REAL_ESTATE_BROKER_DASHBOARD.MOBILE_NAV.COMMISSION');
  if (id === 'investment')
    return t('REAL_ESTATE_BROKER_DASHBOARD.MOBILE_NAV.INVESTMENTS');
  return t('REAL_ESTATE_BROKER_DASHBOARD.MOBILE_NAV.HELP');
};
const commissionLabel = (t, value) => {
  if (value === 'liberado')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.LIBERADO');
  if (value === 'solicitado')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.SOLICITADO');
  if (value === 'em_transferencia')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.EM_TRANSFERENCIA');
  if (value === 'em_andamento')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.EM_ANDAMENTO');
  if (value === 'concluido')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.CONCLUIDO');
  return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.CANCELADO');
};
const temperatureLabel = (t, value) => {
  if (value === 'frio')
    return t('REAL_ESTATE_BROKER_INVESTMENT.TEMPERATURES.FRIO');
  if (value === 'morno')
    return t('REAL_ESTATE_BROKER_INVESTMENT.TEMPERATURES.MORNO');
  return t('REAL_ESTATE_BROKER_INVESTMENT.TEMPERATURES.QUENTE');
};

export const brokerActiveSection = route => {
  if (route.name === 'operacao_imobiliaria_corretor_investimentos') {
    return 'investment';
  }
  if (route.name === 'operacao_imobiliaria_corretor_ajuda') return 'help';
  const section = Array.isArray(route.query?.section)
    ? route.query.section[0]
    : route.query?.section;
  return section === 'comissao' ? 'commission' : 'principal';
};

export const brokerMainNavigationItems = t =>
  [
    ['principal', 'i-heroicons-home-solid'],
    ['commission', 'i-heroicons-currency-dollar-solid'],
    ['investment', 'i-heroicons-wallet-solid'],
    ['help', 'i-heroicons-lifebuoy-solid'],
  ].map(([id, icon]) => ({
    id,
    icon,
    label: mainLabel(t, id),
  }));

export const brokerCommissionNavigationItems = (t, summary) =>
  COMMISSION_STATUS_ORDER.map(value => ({
    value,
    count: summary.find(item => item.key === value)?.count,
    label: commissionLabel(t, value),
  })).filter(item => item.count !== undefined);

export const brokerInvestmentNavigationItems = (t, summary) => {
  if (!Object.prototype.hasOwnProperty.call(summary, 'quantidade_total')) {
    return [];
  }
  const temperatures = summary.temperaturas || [];
  return [
    {
      value: '',
      count: summary.quantidade_total,
      label: t('REAL_ESTATE_BROKER_INVESTMENT.TABS.VGV'),
    },
    ...INVESTMENT_TEMPERATURE_ORDER.map(value => {
      const item = temperatures.find(entry => entry.slug === value);
      return {
        value,
        count: item?.quantidade,
        label: temperatureLabel(t, value),
      };
    }).filter(item => item.count !== undefined),
  ];
};
